<template>
    <div class="view pa24">
        <el-form :model="serchParams" class="demo-form-inline" :inline="true">
            <el-row style="padding-top: 20px;">
                <el-form-item label="设备名称" label-width="100px" label-position="left" class="fromItem" prop="deviceName">
                    <el-input v-model="serchParams.deviceName" placeholder="请输入设备名称"></el-input>
                </el-form-item>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="resetSearch">重置</el-button>
            </el-row>
        </el-form>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部" name="first"></el-tab-pane>
            <el-tab-pane label="待处理" name="second">
                <el-button type="primary" @click="markAllAsKnown" style="margin-right: auto;">全部已知晓</el-button>
            </el-tab-pane>
            <commonTable :tableData="tableData" :total="total" :currentPage="pageNum"
                @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                <template v-slot:table>
                    <el-table-column prop="deviceName" align="center" label="设备名称" />
                    <el-table-column prop="imei" align="center" label="设备IMEI号" />
                    <el-table-column prop="dealerName" align="center" label="经销商名称" />
                    <el-table-column prop="fleeingAddress" align="center" label="地址" />
                    <el-table-column prop="status" align="center" label="窜货状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 3">疑似窜货</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" align="center" label="创建时间" />
                    <el-table-column align="center" label="窜货详情">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showDeviceDetail(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" width="200" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="change(scope.row)"
                                v-if="activeName=='second'">已知晓</el-button>
                            <!-- 查看窜货轨迹 -->
                            <el-button type="text" @click="showGps(scope.row)"
                                v-if="activeName=='first'">查看窜货轨迹</el-button>
                        </template>
                    </el-table-column>
                </template>
            </commonTable>
        </el-tabs>
        <el-dialog title="窜货详情" :visible.sync="dialogVisible" width="60%" :modal-append-to-body="false">
            <commonTable :tableData="dialogTableData" :total="dialogTotal" :currentPage="dialogPageNum" @handleSizeChange="handleDialogSizeChange" @handleCurrentChange="handleDialogCurrentChange">
                <template v-slot:table>
                    <el-table-column label="设备名称" align="center" :formatter="() => currentDevice ? currentDevice.deviceName : ''"></el-table-column>
                    <el-table-column prop="address" label="地址" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
                </template>
            </commonTable>
        </el-dialog>
    </div>
</template>

<script>
    import commonTable from "@/components/common/commonTable";
    import { isRecycle, warning, allKnow, changeStatus, fetchDealerAddress, getFleeingData } from '@/api/gps.js'

    export default {
        name: "dealerList",
        components: {
            commonTable,
        },
        data() {
            return {
                tableData: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                serchParams: {},
                activeName: 'first',
                isKnow: '',
                deviceIds: [],
                dialogVisible: false,
                currentDevice: null,
                dialogPageSize: 10,
                dialogPageNum: 1,
            };
        },
        created() {
            this.getList()
        },
        methods: {
            handleSizeChange(num) {
                this.pageSize = num;
                this.pageNum = 1;
                this.getList();
            },
            handleCurrentChange(num) {
                this.pageNum = num;
                this.getList();
            },
            search() {
                this.pageNum = 1
                this.getList()
            },
            resetSearch() {
                this.serchParams.deviceName = ''
                this.pageNum = 1
                this.getList()
            },
            handleClick(tab, event) {
                console.log(tab, event);
                if (tab.name == 'first') {
                    this.isKnow = ''
                } else if (tab.name == 'second') {
                    this.isKnow = 0
                }
                this.getList()
            },
            getList() {
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    deviceName: this.serchParams.deviceName,
                    isKnow: this.isKnow,
                }
                warning(params).then(res => {
                    if (res.data != null) {
                        this.tableData = res.data.list;
                        this.total = res.data.total;
                    } else {
                        this.tableData = [];
                        this.total = 0;
                    }
                })
            },
            change(row) {
                let params = {
                    deviceId: row.id
                }
                changeStatus(params).then(res => {
                    if (res.code == 200) {
                        this.$message.success('操作成功')
                        this.getList()
                    }
                })
            },
            markAllAsKnown() {
                let params = {
                    pageNum: 1,
                    pageSize: this.total, // 获取所有数据
                    deviceName: this.serchParams.deviceName,
                    isKnow: 0 // 待处理状态
                }
                // let deviceList=this.deviceIds
                warning(params).then(res => {
                    if (res.data && res.data.list) {
                        this.deviceIds = res.data.list.map(item => item.id);
                        this.changeStatusForAll(this.deviceIds);
                    }
                });
            },
            changeStatusForAll(deviceIds) {
                if (deviceIds.length === 0) {
                    this.$message.info('没有待处理的数据');
                    return;
                }
                console.log(deviceIds);
                allKnow({ deviceIds: deviceIds }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('所有数据已标记为已知晓');
                        this.getList();
                    } else {
                        this.$message.error('操作失败，请重试');
                    }
                }
                );
            },
            showDeviceDetail(row) {
                this.currentDevice = Object.assign({}, row, { deviceData: [] });
                this.dialogPageNum = 1;
                this.dialogVisible = true;
                getFleeingData({ deviceId: row.id }).then(res => {
                    if (this.currentDevice && this.currentDevice.id === row.id) {
                        this.$set(this.currentDevice, 'deviceData', res.data || []);
                    }
                });
            },
            showGps(row) {
                // 不传时间，设备轨迹页按最后定位时间往前推7天
                this.$router.push({
                    path: '/gps/gj',
                    query: {
                        dealerId: row.dealerId,
                        deviceId: row.id,
                    },
                });
            },
            handleDialogSizeChange(num) {
                this.dialogPageSize = num;
                this.dialogPageNum = 1;
            },
            handleDialogCurrentChange(num) {
                this.dialogPageNum = num;
            }
        },
        computed: {
            dialogTableData() {
                if (!this.currentDevice || !this.currentDevice.deviceData) return [];
                const start = (this.dialogPageNum - 1) * this.dialogPageSize;
                const end = start + this.dialogPageSize;
                return this.currentDevice.deviceData.slice(start, end);
            },
            dialogTotal() {
                if (!this.currentDevice || !this.currentDevice.deviceData) return 0;
                return this.currentDevice.deviceData.length;
            }
        }
    }
</script>

<style lang="scss" scoped></style>